import { useMutation } from "@tanstack/react-query";
import { UseMutationOptions } from "@tanstack/react-query/src/types";

import { resetStudentPasswords } from "../../../../user/actions/password";

export function useResetPasswords(
  options?: Omit<
    UseMutationOptions<
      unknown,
      unknown,
      { schoolId: string; userIds: string[]; newPassword: string }
    >,
    "mutationFn"
  >
) {
  return useMutation({
    mutationFn: resetStudentPasswords,
    ...options
  });
}
